import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  generatingMessage: false,
  channelId: null as null | string,
};

export const generateChatMessage = createSlice({
  name: "generateChatMessage",
  initialState,
  reducers: {
    setGeneratingMessage: (
      state,
      action: PayloadAction<{
        generating: boolean;
        channelId: string;
      }>
    ) => {
      state.generatingMessage = true;
      state.channelId = action.payload.channelId;
    },

    resetGeneratingMessage: (state, action: PayloadAction<void>) => {
      state.generatingMessage = false;
      state.channelId = null;
    },
  },
});

export const { setGeneratingMessage, resetGeneratingMessage } =
  generateChatMessage.actions;

export default generateChatMessage.reducer;
